<template>
  <div class="empty-state text-center py-5" :class="containerClass">
    <!-- Icon/Illustration -->
    <div class="empty-state-icon mb-3">
      <div v-if="icon" class="avatar-lg mx-auto">
        <div class="avatar-title rounded-circle" :class="iconBgClass">
          <i :class="icon + ' ' + iconClass"></i>
        </div>
      </div>
      <div v-else-if="illustration" class="mb-3">
        <img :src="illustration" :alt="title" style="max-width: 200px; opacity: 0.8;">
      </div>
    </div>

    <!-- Title -->
    <h5 class="text-muted mb-2" v-if="title">{{ title }}</h5>

    <!-- Description -->
    <p class="text-muted mb-4" v-if="description" style="max-width: 400px; margin: 0 auto;">
      {{ description }}
    </p>

    <!-- Action Button -->
    <slot name="action">
      <button 
        v-if="actionText" 
        class="btn btn-sm" 
        :class="actionClass"
        @click="$emit('action')"
      >
        <i v-if="actionIcon" :class="actionIcon + ' me-1'"></i>
        {{ actionText }}
      </button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'fs-24'
    },
    iconBgClass: {
      type: String,
      default: 'bg-soft-light text-muted'
    },
    illustration: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    actionText: {
      type: String,
      default: ''
    },
    actionIcon: {
      type: String,
      default: ''
    },
    actionClass: {
      type: String,
      default: 'btn-primary'
    },
    containerClass: {
      type: String,
      default: ''
    }
  },
  emits: ['action']
};
</script>

<style scoped>
.empty-state {
  animation: fadeIn 0.4s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.empty-state-icon {
  animation: fadeIn 0.5s ease-in 0.1s both;
}
</style>
